import Vue from 'vue';
import Router from 'vue-router';
import AppLayout from '../components/AppLayout.vue';
import nofooterAppLayout from '../components/nofooterAppLayout.vue';
// import rawMaterialsRouter from "@/router/modules/rawMaterials";
// import productionBaseRouter from "@/router/modules/productionBase";
// import offlineRouter from "@/router/modules/offline";


Vue.use(Router);

export const constantRoutes = [

	{
		path: '/',
		component: AppLayout,
		redirect: '/index',
		meta: {
		  title: "首页",
		  id:'0'
		},
		children: [{
			path: 'index',
			name: 'Index',
			component: () => import('@/views/index/index'),
			meta: {
				title: 'index',
				icon: 'index'
			}
		}]
	},
	{
		path: '/productplatform',
		component: AppLayout,
		redirect: '/productplatform',
		meta: {
			title: "供应链",
			id:'208'
		},
		children: [{
				path: 'index/:type',
				name: 'productplatform',
				component: () => import('@/views/productplatform/index'),
				meta: {
					title: '供应链',
					icon: 'productplatform'
				}
			},
			{
				path: "see/:id",
				component: () => import("@/views/productplatform/see"),
				hidden: true,
				name: "productplatform_see",
				meta: {
					title: "供应链",
					bread: "供应链,详情",
					noCache: true,
					navigation: "/productplatform/see",
					// icon: "menu_big_data"
				}
			},
		]
	},
	{
		path: '/newsCenter',
		component: AppLayout,
		redirect: '/newsCenter',
		meta: {
			title: "新闻资讯",
			id:'209'
		},
		children: [{
				path: 'index/:type',
				name: 'newsCenter',
				component: () => import('@/views/newsCenter/index'),
				meta: {
					title: '新闻资讯',
					icon: 'newsCenter'
				}
			},
			{
				path: "see/:id",
				component: () => import("@/views/newsCenter/see"),
				hidden: true,
				name: "newsCenter_see",
				meta: {
					title: "新闻资讯",
					bread: "新闻资讯,新闻详情",
					noCache: true,
					navigation: "/newsCenter/see",
					// icon: "menu_big_data"
				}
			},
		]
	},
	{
		path: '/404',
		component: () => import('@/views/404'),
		hidden: true
	},

	// 404 page must be placed at the end !!!
	{
		path: '*',
		redirect: '/404',
		hidden: true
	},
	// rawMaterialsRouter,
	// productionBaseRouter,
	// offlineRouter,
	
	{
		path: '/production',
		component: AppLayout,
		redirect: '/production',
		meta: {
			title: "生产园区",
			id:'201'
		},
		children: [{
				path: 'index/:type',
				props: true,
				name: 'production',
				component: () => import('@/views/productionPark/index'),
				meta: {
					title: 'production',
				}
			},
		]
	},
	{
		path: '/exhibition',
		component: AppLayout,
		redirect: '/exhibition',
		meta: {
			title: "会展服务",
			id:'202'
		},
		children: [{
				path: 'index/:type',
				props: true,
				name: 'exhibition',
				component: () => import('@/views/exhibition/index'),
				meta: {
					title: 'exhibition',
				}
			},
		]
	},
	{
		path: '/business',
		component: AppLayout,
		redirect: '/business',
		meta: {
			title: "业务介绍",
			id:'203'
		},
		children: [
			{
				path: 'index/:type',
				props: true,
				name: 'index',
				component: () => import('@/views/business/index'),
				meta: {
					title: 'index',
				}
			}
		]
	},
	{
		path: '/logisticsAndTaxation',
		component: AppLayout,
		redirect: '/logisticsAndTaxation',
		meta: {
			title: "物流保税",
			id:'204'
		},
		children: [{
				path: 'logisticsService/:type',
				props: true,
				name: 'logisticsService',
				component: () => import('@/views/logisticsAndTaxation/logisticsService'),
				meta: {
					title: '物流服务',
				}
			},
		]
	},
	{
		path: '/associationEvent',
		component: AppLayout,
		redirect: '/associationEvent',
		meta: {
			title: "协会大事记",
			id:'205'
		},
		children: [{
				path: 'index',
				props: true,
				name: 'index',
				component: () => import('@/views/associationEvent/index'),
				meta: {
					title: '协会大事记',
				}
			},
		]
	},
	{
		path: '/investmentCooperation',
		component: AppLayout,
		redirect: '/investmentCooperation',
		meta: {
			title: "合作招商",
			id:'206'
		},
		children: [{
				path: 'index/:type',
				props: true,
				name: 'index',
				component: () => import('@/views/investmentCooperation/index'),
				meta: {
					title: '合作招商',
				}
			},
		]
	},
	{
		path: '/infoCollection',
		component: nofooterAppLayout,
		redirect: '/infoCollection',
		meta: {
			title: "信息采集",
			id:'208'
		},
		children: [{
				path: 'index',
				props: true,
				name: 'infoCollectionIndex',
				component: () => import('@/views/investmentCooperation/infoCollection'),
				meta: {
					title: '信息采集',
				}
			}
		]
	},
	{
		path: '/introduction',
		component: AppLayout,
		redirect: '/introduction',
		meta: {
			title: "平台介绍",
			id:'207'
		},
		children: [{
				path: 'index',
				props: true,
				name: 'introduction',
				component: () => import('@/views/introduction/index'),
				meta: {
					title: 'introduction',
					icon: 'introduction'
				}
			},
		]
	},
];

const createRouter = () => new Router({
	// mode: 'history', // require service support\
	mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router;